const { PaymentTransactionStatusEnum } = require("./enums");

export const TransactionsTagColorMap = {
  [PaymentTransactionStatusEnum.Approved]: "success",
  [PaymentTransactionStatusEnum.Declined]: "error",
  [PaymentTransactionStatusEnum.Pending]: "processing",
  [PaymentTransactionStatusEnum.Error]: "error",
};
